import React, { Component } from "react";
import Form from "../comman/form";
import { Modal, Button } from "react-bootstrap";
import Moment from "react-moment";
import config from "../config.json";

class PaymentPopup extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          id: "234",
          transactionDateTime: "2020-07-13 15:01:09.423",
          amount: "32",
          responseObj:
            '{"transactionResponse":{"responseCode":"1","rawResponseCode":null,"authCode":"H1PSRW","avsResultCode":"Y","cvvResultCode":"P","cavvResultCode":"2","transId":"40051857102","refTransID":"","transHash":"","testRequest":"0","accountNumber":"XXXX1111","entryMode":null,"accountType":"Visa","splitTenderId":null,"prePaidCard":null,"messages":[{"code":"1","description":"This transaction has been approved."}],"errors":null,"splitTenderPayments":null,"userFields":null,"shipTo":null,"secureAcceptance":null,"emvResponse":null,"transHashSha2":"","profile":null,"networkTransId":"2PIUL6XPP9EKKM5BRX38KYN"},"profileResponse":null,"refId":null,"messages":{"resultCode":0,"message":[{"code":"I00001","text":"Successful."}]},"sessionToken":null}',
        },
      ],
      errors: {},
      selectedObj: {},
    };
  }

  getResponseObj(responseObj) {
    const { transactionResponse: resObj } = JSON.parse(responseObj);
    if (resObj) return resObj.messages[0].description;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedObj) {
      const { selectedObj } = nextProps;
      this.setState({ selectedObj });
    }
  }

  render() {
    const { paymentShowHide, handlePaymentModalShowHide, selectedObj } =
      this.props;
    //console.log(selectedObj);
    return (
      <Modal show={paymentShowHide}>
        <Modal.Header closeButton onClick={handlePaymentModalShowHide}>
          <Modal.Title>Payment Receipt</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          {selectedObj &&
            selectedObj?.paymentDetails &&
            selectedObj?.paymentDetails?.authResponse !== null && (
              <div className="row">
                <div className="col-md-12 text-center">
                  <h2>Payment Successfull</h2>
                  <i
                    className="fa fa-check-circle-o display-1 text-success"
                    aria-hidden="true"
                  ></i>
                </div>
                <div className="col-md-12 text-right">
                  {selectedObj.paymentDetails !== undefined && (
                    <a
                      href={
                        config.CreatePdf + selectedObj.paymentDetails.paymentId
                      }
                      className="btn btn-outline-default btn-sm"
                      target="_blank"
                    >
                      <i className="fa fa-print"></i> Print
                    </a>
                  )}
                </div>
                <div className="col-md-12">
                  <table className="table align-items-center table-flush table-hover bg-white table-bordered mt-2">
                    <tbody>
                      <tr>
                        <td className="w-10 font-weight-bold">
                          Applicant ID :
                        </td>
                        <td> {selectedObj.regId}</td>
                        <td className="w-10 text-right font-weight-bold">
                          Document # :{" "}
                        </td>
                        <td>PBC00{selectedObj.paymentDetails.paymentId}</td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">Email : </td>
                        <td colSpan="3">{selectedObj.email}</td>
                      </tr>
                      <tr>
                        <td className="align-top font-weight-bold">
                          Bill To :{" "}
                        </td>
                        <td colSpan="3">
                          {selectedObj.paymentDetails.billTo.address}
                          <br />
                          {selectedObj.paymentDetails.billTo.state},{" "}
                          {selectedObj.paymentDetails.billTo.city}
                          <br />
                          {selectedObj.paymentDetails.billTo.country},{" "}
                          {selectedObj.paymentDetails.billTo.zip}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="col-md-12">
                  <h3>Payment Details : </h3>
                  <table className="table align-items-center table-flush table-hover bg-white table-striped">
                    <thead className="thead-light">
                      <tr>
                        <td className="font-weight-bold">Order # : </td>
                        <td>APP00{selectedObj.appId}</td>
                      </tr>
                      <tr>
                        <td className="w-25 font-weight-bold">
                          Receipt # / Transaction ID :{" "}
                        </td>
                        <td>
                          {
                            selectedObj.paymentDetails.authResponse
                              .transactionResponse.transId
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">Total Paid :</td>
                        <td>${selectedObj.paymentDetails.amount}</td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">Transaction Date :</td>
                        <td>{selectedObj.paymentDetails.paymentDate}</td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">Payment Method :</td>
                        <td>Credit Card</td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">Card Number :</td>
                        <td>
                          {
                            selectedObj.paymentDetails.authResponse
                              .transactionResponse.accountNumber
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">Expiry Date :</td>
                        <td>
                          {selectedObj.paymentDetails.creditCard.expirationDate}
                        </td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">Name on the Card :</td>
                        <td>{selectedObj.paymentDetails.billTo.firstName}</td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">
                          Authorization Code :
                        </td>
                        <td>
                          {
                            selectedObj.paymentDetails.authResponse
                              .transactionResponse.authCode
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">
                          Transaction Message :
                        </td>
                        <td>
                          {
                            selectedObj.paymentDetails.authResponse.messages
                              .message[0].text
                          }
                        </td>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            )}
        </Modal.Body>
        <Modal.Footer>
          {selectedObj && selectedObj?.paymentDetails && (
            <a
              href={config.CreatePdf + selectedObj.paymentDetails.paymentId}
              className="btn btn-outline-default-outline btn-sm"
              target="_blank"
            >
              <i className="fa fa-print"></i> Print
            </a>
          )}
          {/* <Button variant="danger" onClick={handlePaymentModalShowHide}>
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </Button> */}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PaymentPopup;
